<template>
    <div class="pwaLoginWrap">

        <div class="mainLogoGroup">
            <div class="mainLogo">
                <img src="static/img/icon-192.png"  alt="雲林數位農業行動平台">
                <h2>雲林數位農業行動平台</h2>
            </div>
        </div>

        <!-- 一般PWA 登入畫面 -->
        <div class="pwaLoginGroup" v-if="!isCordovaWebView">
            <p>第三方平台登入</p> 
            <div class="pwaLogin">
                
              <!-- 帳戶登入(Line) -->
                <div @click="loginLine()" size="lg" class="btn-line" style="width: 200px;padding: 6px;">
                    <img style="margin-right: 15px;" src="static/img/btn_line_base.png" alt="Kitten" class="d-inline-block logo img-fluid" />
                    <span style="font-size:14px;color:#FFFFFF;">使用 Line 帳戶登入</span>
                </div><br /><br />
                
                <!-- 帳戶登入(Facebook) -->
                <div @click="loginFb()" size="lg" class="btn-fb" style="width: 200px;padding: 6px;">
                    <img style="margin-right: 15px;" src="static/img/btn_fb_base.png" alt="Kitten" class="d-inline-block logo img-fluid" />
                    <span style="font-size:14px;color:#FFFFFF;">使用 FB 帳戶登入</span>
                </div><br /><br />

                <!-- 帳戶登入(Google) -->
                <div    id="g_id_onload"
                        data-client_id="1040266710179-qhi90mf2d286go5tur3qnognkiq2qlrg.apps.googleusercontent.com"
                        data-context="signin"
                        data-callback="handleCredentialResponse"
                        data-itp_support="true"
                        data-auto_select="false">
                </div>
                <div style="width:200px;display: inline-block;">
                    <div  class="g_id_signin"
                            data-type="standard"
                            data-size="large"
                            data-theme="outline"
                            data-text="sign_in_with"
                            data-shape="rectangular"
                            data-logo_alignment="left">
                    </div>
                </div>

            </div>        
        </div>

        <!-- app 登入畫面 -->
        <div class="pwaLoginGroup" v-if="isCordovaWebView">        

            <!-- 手機號碼登入 -->
            <div class="pwaLogin account">
              <div style="width: 200px;padding-top: 20px;">
                <input class="w3-input w3-border" type="text" maxlength="10" v-model="input.account.value"  :placeholder="input.account.placeholder">
                <div @click="checkPhone()" size="lg" class="btn-phone" style="width: 200px; padding: 6px; margin-bottom: 4.5px;"><span style="font-size: 14px; color: rgb(255, 255, 255);">手機號碼登入</span></div>
                <div @click="loginVisitor()" size="lg" class="btn-visitor" style="width: 200px; padding: 6px; margin-bottom: 4.5px;"><span style="font-size: 14px; color: rgb(255, 255, 255);">一般訪客登入</span></div>
              </div>
            </div>

        </div>

        <!-- 彈出視窗(手機號碼輸入發送簡訊的驗證碼) -->
        <ModalWindow 
            :show="modal.phone.show"
            :textTitle="modal.phone.title"
            :maxWidth="'720px'"
            @ClickClose="modal.phone.show = false;">

            <div style="width: 200px; margin: 0 auto;" class="pwaLogin account">
              <p>驗證碼已送到 {{ input.account.value }}</p>
              <input class="w3-input w3-border" type="text" maxlength="6" v-model="input.password.value" :placeholder="input.password.placeholder" >
              <div @click="loginPhone()" class="btn-pw" style="width: 200px; padding: 6px; margin: 4.5px auto;" >
                <span style="font-size: 14px; color: #fff;">送出驗證碼</span>
              </div>
          </div>
      </ModalWindow>

    </div>
    
</template>

<script>
import ModalWindow from '@/components/pwa/ModalWindow.vue'
export default {
  name: 'Login',
  data(){
    return {
      //判別是否為app
      isCordovaWebView:false,
      //表單物件
      input:{
 
        account:{               
          text:"帳號",  
          value:"",
          placeholder:"請輸入手機號碼",
          list:[],
        },
        password:{                   
          text:"驗證碼",
          value:"",
          placeholder:"請輸入驗證碼",
          list:[],
        },
      },
      //彈出視窗
      modal:{   
          
          //主產作物
          phone:{
              //是否呈現
              show:false,
              //目前選取的索引值
              index:0,
              //標題
              title:"請輸入簡訊碼",
              //目前選擇
              select:"",
              //圖示
              icon:"",
              //清單
              list:[]
          },
      },
      //帳戶登入(Line)
      apiLineOption: (data) => this.userRequest.post("/API/Default/LineOption", data),
      //帳戶登入(Google)
      apiGoogleLogin: (data) => this.userRequest.post("/API/Default/GoogleLogin", data),
      //帳戶登入(Facebook)
      apiFbLogin: (data) => this.userRequest.post("/API/Default/FbLogin", data),
      //帳戶登入(手機號碼)
      apiPhoneCheck: (data) => this.userRequest.post("/API/Default/PhoneCheck", data),
      //帳戶登入(手機號碼)(確認驗證碼)
      apiPhoneLogin: (data) => this.userRequest.post("/API/Default/PhoneLogin", data),

    }
  },
  created() {
    window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                        //例如:window.vue._data.map.getCesiumScene().setEnabled(false);

    //順便補充，如果vue認不得外部定義的函式，可以藉由 window 變數
    //像是一般呼叫外部函式 是這樣 Browser.GetLocationRootUrl()
    //但在Vue要呼叫時，則是 window.Browser.GetLocationRootUrl()
        
    //在手機 chrom瀏覽器 sessionStorage.setItem、sessionStorage.getItem 會在Line導回來後取不到      
    sessionStorage.setItem("backurl", "PWA");
    localStorage.setItem("backurl", "PWA");      
  },
  components: {
        ModalWindow
  },
  mounted(){

    //判別是否為app(只有app才會有 isCordovaWebView 狀態)
    this.isCordovaWebView = localStorage.getItem("isCordovaWebView") === "true";

    //若已登入，讓使用者不能再走訪登入頁面
    let TokenID = sessionStorage.getItem("TokenID");
    if(TokenID){
      this.$router.push({ path: "/PwaLogin" });
    }

    //重新刷新Google登入按鈕(因為Vue只是切換View，導致按鈕會無法正常呈現，所以在 mounted 就必須重新渲染)
    window.google.accounts.id.initialize({
      client_id: "1040266710179-qhi90mf2d286go5tur3qnognkiq2qlrg.apps.googleusercontent.com",
      callback: this.handleCredentialResponse,
    });
    window.google.accounts.id.renderButton(
      document.querySelector(".g_id_signin"),
      { theme: "outline", size: "large" } // 可調整樣式
    );
    
  },
  watch: {

  },
  methods:{
    //帳戶登入(Line)
    loginLine(){

      //這邊先設定登入成功要導向的網址(給首頁導向用的)
      var url = new URL(location.href.replace("/#","").replace("/?#",""));
      var backurl = url.searchParams.get("backurl");

      if(backurl != null)
      {
        sessionStorage.setItem("backurl", backurl);
        localStorage.setItem("backurl", backurl);
      }

      var data = {};
      this.apiLineOption(data)
      .then((res)=>{
        const json = JSON.parse(res.data)
        console.log(json)

        let client_id = json.client_id;                                    //後台的Channel ID
        let redirect_uri = json.redirect_uri;                              //登入成功後，要導向的網址(必須要和後台設定的一樣，不然會報錯)      
        let authorize_uri = json.authorize_uri;                            //Line官方驗證登入的網址(LINE Login 授權URL)              
        let state = json.state;

        authorize_uri += '?';
        authorize_uri += 'response_type=code';
        authorize_uri += '&client_id=' + client_id;
        authorize_uri += '&redirect_uri=' + redirect_uri;
        //authorize_uri += '&state=' + state;
        authorize_uri += '&state=login_pwa';
        authorize_uri += '&scope=openid%20profile';
            
        //console.log(authorize_uri);
        console.log(state);
        window.location.href = authorize_uri;

      })
      .catch((err)=> {
        console.log(err)
      });

    },

    //帳戶登入(Google)
    loginGoogle(data){

      this.apiGoogleLogin(data)
      .then((res)=>{
        const json = JSON.parse(res.data)
        console.log(json)
        let UserInfo = json.AgriUserInfo;

        let AC_ID = UserInfo.AC_ID;
        let AC_USERID = UserInfo.AC_USERID;
        let AC_USERNAME = UserInfo.AC_USERNAME;
        let AC_PWD = UserInfo.AC_PWD;
        let AC_USERTYPE = UserInfo.AC_USERTYPE;
        let AC_STATUS = UserInfo.AC_STATUS;
        let AC_GROUP_ID = UserInfo.AC_GROUP_ID;
        let AC_TITLE = UserInfo.AC_TITLE;
        let AC_TEL_EX = UserInfo.AC_TEL_EX;
        let AC_KEYID = UserInfo.AC_KEYID;
        let AC_SEX = UserInfo.AC_SEX;
        let AC_IDNUM = UserInfo.AC_IDNUM;
        let AC_BIRTHDAY = UserInfo.AC_BIRTHDAY;
        let AC_CONTACT = UserInfo.AC_CONTACT;
        let AC_POST = UserInfo.AC_POST;
        let AC_CITYID = UserInfo.AC_CITYID;
        let AC_TOWNID = UserInfo.AC_TOWNID;
        let AC_ADDRESS = UserInfo.AC_ADDRESS;
        let AC_TEL = UserInfo.AC_TEL;
        let AC_MOBILE = UserInfo.AC_MOBILE;
        let AC_FAX = UserInfo.AC_FAX;
        let AC_EMAIL = UserInfo.AC_EMAIL;
        let AC_CONTENT = UserInfo.AC_CONTENT;
        let AC_IMG = UserInfo.AC_IMG;
        let AC_ORDER = UserInfo.AC_ORDER;
        let AC_VCOUNT = UserInfo.AC_VCOUNT;
        let AC_MDATE = UserInfo.AC_MDATE;
        let AC_EDATE = UserInfo.AC_EDATE;
        let AC_EUSER = UserInfo.AC_EUSER;
        let AC_LOGINSET = UserInfo.AC_LOGINSET;
        let AC_ISDEL = UserInfo.AC_ISDEL;
        let AC_NOTIFY = UserInfo.AC_NOTIFY;
        let AC_ERROR_TIME = UserInfo.AC_ERROR_TIME;
        let AC_ERROR_COUNT = UserInfo.AC_ERROR_COUNT;
        let AC_LINE_USER_ID = UserInfo.AC_LINE_USER_ID;

        let UserName = UserInfo.UserName;
        let TokenID = UserInfo.TokenID;
        let DisposableLine = UserInfo.DisposableLine;

        console.log(AC_ID);
        console.log(AC_USERID);
        console.log(AC_USERNAME);
        console.log(AC_PWD);
        console.log(AC_USERTYPE);
        console.log(AC_STATUS);
        console.log(AC_GROUP_ID);
        console.log(AC_TITLE);
        console.log(AC_TEL_EX);
        console.log(AC_KEYID);
        console.log(AC_SEX);
        console.log(AC_IDNUM);
        console.log(AC_BIRTHDAY);
        console.log(AC_CONTACT);
        console.log(AC_POST);
        console.log(AC_CITYID);
        console.log(AC_TOWNID);
        console.log(AC_ADDRESS);
        console.log(AC_TEL);
        console.log(AC_MOBILE);
        console.log(AC_FAX);
        console.log(AC_EMAIL);
        console.log(AC_CONTENT);
        console.log(AC_IMG);
        console.log(AC_ORDER);
        console.log(AC_VCOUNT);
        console.log(AC_MDATE);
        console.log(AC_EDATE);
        console.log(AC_EUSER);
        console.log(AC_LOGINSET);
        console.log(AC_ISDEL);
        console.log(AC_NOTIFY);
        console.log(AC_ERROR_TIME);
        console.log(AC_ERROR_COUNT);
        console.log(AC_LINE_USER_ID);

        console.log(UserName);
        console.log(TokenID);
        console.log(DisposableLine);

        sessionStorage.setItem("TokenID", TokenID);
        sessionStorage.setItem("username", UserName);
        sessionStorage.setItem("AC_GROUP_ID", AC_GROUP_ID);

        localStorage.setItem("TokenID", TokenID);
        localStorage.setItem("username", UserName);
        localStorage.setItem("AC_GROUP_ID", AC_GROUP_ID);
        
        if(Number(DisposableLine) == 1){

            sessionStorage.setItem("disposable_line", "1");
            localStorage.setItem("disposable_line", "1");
        }

        window.setPage("home");

      })
      .catch((err)=> {
        console.log(err)
      });

    },

    //帳戶登入(Facebook)
    loginFb(){

      //因為Vue可能因載入有問題，所以把他寫到這裡
      window.FB.init({
        appId: '1094128766255343',
        cookie: true,
        xfbml: false,
        version: 'v23.0'
      });

      window.FB.login(function (response) {
        if (response.authResponse) {
          // 登入成功，取得使用者資料
          window.FB.api('/me', { fields: 'name,email,picture' }, function (user) {
        
            window.vue.loginFbBase(user);
          });
        } else {
          console.log('使用者取消登入或未授權');
        }
      }, { scope: 'public_profile,email' });
    },
    //帳戶登入(Facebook)(基本操作)
    loginFbBase(data){

      this.apiFbLogin(data)
      .then((res)=>{
        const json = JSON.parse(res.data)
        console.log(json)
        let UserInfo = json.AgriUserInfo;

        let AC_ID = UserInfo.AC_ID;
        let AC_USERID = UserInfo.AC_USERID;
        let AC_USERNAME = UserInfo.AC_USERNAME;
        let AC_PWD = UserInfo.AC_PWD;
        let AC_USERTYPE = UserInfo.AC_USERTYPE;
        let AC_STATUS = UserInfo.AC_STATUS;
        let AC_GROUP_ID = UserInfo.AC_GROUP_ID;
        let AC_TITLE = UserInfo.AC_TITLE;
        let AC_TEL_EX = UserInfo.AC_TEL_EX;
        let AC_KEYID = UserInfo.AC_KEYID;
        let AC_SEX = UserInfo.AC_SEX;
        let AC_IDNUM = UserInfo.AC_IDNUM;
        let AC_BIRTHDAY = UserInfo.AC_BIRTHDAY;
        let AC_CONTACT = UserInfo.AC_CONTACT;
        let AC_POST = UserInfo.AC_POST;
        let AC_CITYID = UserInfo.AC_CITYID;
        let AC_TOWNID = UserInfo.AC_TOWNID;
        let AC_ADDRESS = UserInfo.AC_ADDRESS;
        let AC_TEL = UserInfo.AC_TEL;
        let AC_MOBILE = UserInfo.AC_MOBILE;
        let AC_FAX = UserInfo.AC_FAX;
        let AC_EMAIL = UserInfo.AC_EMAIL;
        let AC_CONTENT = UserInfo.AC_CONTENT;
        let AC_IMG = UserInfo.AC_IMG;
        let AC_ORDER = UserInfo.AC_ORDER;
        let AC_VCOUNT = UserInfo.AC_VCOUNT;
        let AC_MDATE = UserInfo.AC_MDATE;
        let AC_EDATE = UserInfo.AC_EDATE;
        let AC_EUSER = UserInfo.AC_EUSER;
        let AC_LOGINSET = UserInfo.AC_LOGINSET;
        let AC_ISDEL = UserInfo.AC_ISDEL;
        let AC_NOTIFY = UserInfo.AC_NOTIFY;
        let AC_ERROR_TIME = UserInfo.AC_ERROR_TIME;
        let AC_ERROR_COUNT = UserInfo.AC_ERROR_COUNT;
        let AC_LINE_USER_ID = UserInfo.AC_LINE_USER_ID;

        let UserName = UserInfo.UserName;
        let TokenID = UserInfo.TokenID;
        let DisposableLine = UserInfo.DisposableLine;

        console.log(AC_ID);
        console.log(AC_USERID);
        console.log(AC_USERNAME);
        console.log(AC_PWD);
        console.log(AC_USERTYPE);
        console.log(AC_STATUS);
        console.log(AC_GROUP_ID);
        console.log(AC_TITLE);
        console.log(AC_TEL_EX);
        console.log(AC_KEYID);
        console.log(AC_SEX);
        console.log(AC_IDNUM);
        console.log(AC_BIRTHDAY);
        console.log(AC_CONTACT);
        console.log(AC_POST);
        console.log(AC_CITYID);
        console.log(AC_TOWNID);
        console.log(AC_ADDRESS);
        console.log(AC_TEL);
        console.log(AC_MOBILE);
        console.log(AC_FAX);
        console.log(AC_EMAIL);
        console.log(AC_CONTENT);
        console.log(AC_IMG);
        console.log(AC_ORDER);
        console.log(AC_VCOUNT);
        console.log(AC_MDATE);
        console.log(AC_EDATE);
        console.log(AC_EUSER);
        console.log(AC_LOGINSET);
        console.log(AC_ISDEL);
        console.log(AC_NOTIFY);
        console.log(AC_ERROR_TIME);
        console.log(AC_ERROR_COUNT);
        console.log(AC_LINE_USER_ID);

        console.log(UserName);
        console.log(TokenID);
        console.log(DisposableLine);

        sessionStorage.setItem("TokenID", TokenID);
        sessionStorage.setItem("username", UserName);
        sessionStorage.setItem("AC_GROUP_ID", AC_GROUP_ID);

        localStorage.setItem("TokenID", TokenID);
        localStorage.setItem("username", UserName);
        localStorage.setItem("AC_GROUP_ID", AC_GROUP_ID);
        
        if(Number(DisposableLine) == 1){

            sessionStorage.setItem("disposable_line", "1");
            localStorage.setItem("disposable_line", "1");
        }

        window.setPage("home");

      })
      .catch((err)=> {
        console.log(err)
      });
    },

    //帳戶登入(Google)(回調函式)
    handleCredentialResponse(response) {

      // 解析 JWT 並顯示用戶資訊（僅作為示例，請謹慎處理 JWT）
      const base64Url = response.credential.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );

      var json = JSON.parse(jsonPayload);
      this.loginGoogle(json);
    },

    //驗證是否為手機號碼
    isValidTaiwanMobile(phone) {
      const regex = /^09\d{8}$/;
      return regex.test(phone);
    },

    //清除手機號碼登入相關欄位
    clearPhone(){

      this.input.account.value = "";
      this.input.password.value = "";
    },

    //手機確認是否輸入正確
    checkPhone(){

      if(this.isValidTaiwanMobile(this.input.account.value))
      {
        this.apiPhoneCheck({
          AC_USERID:this.input.account.value,
        })
        .then((res)=>{
          const data = JSON.parse(res.data)
          console.log(data);
          if(data.length > 0)
          {
            this.modal.phone.show = true;
          }
        })
        .catch((err)=> {
          console.log(err)
        });
      }
      else
      {
        if(this.input.account.value.length == 0)
        {
          alert("請輸入手機號碼");
          return false;
        }
        if(this.input.account.value.length < 10)
        {
          alert("請輸入10碼的手機號碼");
          return false;
        }
        alert("無效的手機號碼格式");
      }
    },
    
    //手機號碼登入
    loginPhone(){

      if(this.input.password.value.length == 0)
      {
        alert("請輸入驗證碼");
        return false;
      }

      if(this.input.password.value.length < 6)
      {
        alert("請輸入6碼的驗證碼");
        return false;
      }

      this.apiPhoneLogin({
        AC_USERID:this.input.account.value,
        AC_PWD:this.input.password.value
      })
      .then((res)=>{
        const data = JSON.parse(res.data)
        console.log(data);

        if(data.length > 0)
        {
          alert("登入成功");
          let UserInfo = data[0];

          let AC_ID = UserInfo.AC_ID;
          let AC_USERID = UserInfo.AC_USERID;
          let AC_USERNAME = UserInfo.AC_USERNAME;
          let AC_PWD = UserInfo.AC_PWD;
          let AC_USERTYPE = UserInfo.AC_USERTYPE;
          let AC_STATUS = UserInfo.AC_STATUS;
          let AC_GROUP_ID = UserInfo.AC_GROUP_ID;
          let AC_TITLE = UserInfo.AC_TITLE;
          let AC_TEL_EX = UserInfo.AC_TEL_EX;
          let AC_KEYID = UserInfo.AC_KEYID;
          let AC_SEX = UserInfo.AC_SEX;
          let AC_IDNUM = UserInfo.AC_IDNUM;
          let AC_BIRTHDAY = UserInfo.AC_BIRTHDAY;
          let AC_CONTACT = UserInfo.AC_CONTACT;
          let AC_POST = UserInfo.AC_POST;
          let AC_CITYID = UserInfo.AC_CITYID;
          let AC_TOWNID = UserInfo.AC_TOWNID;
          let AC_ADDRESS = UserInfo.AC_ADDRESS;
          let AC_TEL = UserInfo.AC_TEL;
          let AC_MOBILE = UserInfo.AC_MOBILE;
          let AC_FAX = UserInfo.AC_FAX;
          let AC_EMAIL = UserInfo.AC_EMAIL;
          let AC_CONTENT = UserInfo.AC_CONTENT;
          let AC_IMG = UserInfo.AC_IMG;
          let AC_ORDER = UserInfo.AC_ORDER;
          let AC_VCOUNT = UserInfo.AC_VCOUNT;
          let AC_MDATE = UserInfo.AC_MDATE;
          let AC_EDATE = UserInfo.AC_EDATE;
          let AC_EUSER = UserInfo.AC_EUSER;
          let AC_LOGINSET = UserInfo.AC_LOGINSET;
          let AC_ISDEL = UserInfo.AC_ISDEL;
          let AC_NOTIFY = UserInfo.AC_NOTIFY;
          let AC_ERROR_TIME = UserInfo.AC_ERROR_TIME;
          let AC_ERROR_COUNT = UserInfo.AC_ERROR_COUNT;
          let AC_LINE_USER_ID = UserInfo.AC_LINE_USER_ID;

          let UserName = UserInfo.UserName;
          let TokenID = UserInfo.TokenID;
          let DisposableLine = UserInfo.DisposableLine;

          console.log(AC_ID);
          console.log(AC_USERID);
          console.log(AC_USERNAME);
          console.log(AC_PWD);
          console.log(AC_USERTYPE);
          console.log(AC_STATUS);
          console.log(AC_GROUP_ID);
          console.log(AC_TITLE);
          console.log(AC_TEL_EX);
          console.log(AC_KEYID);
          console.log(AC_SEX);
          console.log(AC_IDNUM);
          console.log(AC_BIRTHDAY);
          console.log(AC_CONTACT);
          console.log(AC_POST);
          console.log(AC_CITYID);
          console.log(AC_TOWNID);
          console.log(AC_ADDRESS);
          console.log(AC_TEL);
          console.log(AC_MOBILE);
          console.log(AC_FAX);
          console.log(AC_EMAIL);
          console.log(AC_CONTENT);
          console.log(AC_IMG);
          console.log(AC_ORDER);
          console.log(AC_VCOUNT);
          console.log(AC_MDATE);
          console.log(AC_EDATE);
          console.log(AC_EUSER);
          console.log(AC_LOGINSET);
          console.log(AC_ISDEL);
          console.log(AC_NOTIFY);
          console.log(AC_ERROR_TIME);
          console.log(AC_ERROR_COUNT);
          console.log(AC_LINE_USER_ID);

          console.log(UserName);
          console.log(TokenID);
          console.log(DisposableLine);

          sessionStorage.setItem("TokenID", TokenID);
          sessionStorage.setItem("username", UserName);
          sessionStorage.setItem("AC_GROUP_ID", AC_GROUP_ID);

          localStorage.setItem("TokenID", TokenID);
          localStorage.setItem("username", UserName);
          localStorage.setItem("AC_GROUP_ID", AC_GROUP_ID);
          
          if(Number(DisposableLine) == 1){

              sessionStorage.setItem("disposable_line", "1");
              localStorage.setItem("disposable_line", "1");
          }

          window.setPage("home");

        }else{

          alert("驗證碼輸入錯誤");
          this.clearPhone();
          this.modal.phone.show = false;
        }

      })
      .catch((err)=> {
        console.log(err)
      });

    },

    //一般訪客登入
    loginVisitor(){

      sessionStorage.setItem("TokenID",  "-1");
      sessionStorage.setItem("username",  "1");
      sessionStorage.setItem("AC_GROUP_ID",  "1");
      sessionStorage.setItem("disposable_line", "1");

      localStorage.setItem("TokenID",  "-1");
      localStorage.setItem("username",  "1");
      localStorage.setItem("AC_GROUP_ID",  "1");
      localStorage.setItem("disposable_line", "1");
      window.setPage("home");
    },

  }
}
</script>
<style>

  /** 帳戶  */
  .account {
    text-align: -webkit-center;
  }

  /** 帳戶(表單物件)  */
  .account input{
    padding:4.5px;
    margin-bottom: 4.5px;
    text-align: center;
  }

  /** 按鈕(表單物件) */
  .btn-phone{
      background-color: #da8311;
      display: inline-block;
      img{
          height: 29px;
          width: 29px;
      }
  }

  /** 按鈕(手機號碼登入) */
  .btn-visitor{
      background-color: #11da43a4;
      display: inline-block;
      img{
          height: 29px;
          width: 29px;
      }
  }

  /** 按鈕(一般訪客登入) */
  .btn-pw{
      background-color: #5711da;
      display: inline-block;
      img{
          height: 29px;
          width: 29px;
      }
  }

</style>


